/**
 * @file 考试课程API
 * @author 小白
 */

import request from "@/utils/request";

export function login(data) {
  return request({
    url: "/user/login",
    method: "post",
    data,
  });
}

export async function getUserInfo() {
  return request.get("/user");
}

// 获取用户信息 
export async function getStudentInfo() {
  return request.get("/studentAccount/getStudentAccount");
}

// 获取学籍信息
export async function getUserArchives() {
  return request.get("/user/archives");
}

// 发送修改密码短信验证码
export async function sendModifyPasswordCaptcha(data) {
  return request.post("/user/modifyPassword/captcha", data);
}

// 修改密码
export async function modifyPassword(data) {
  return request.post("/user/modifyPassword", data);
}

// 获取问题课程
export async function getQuestionCourse(data) {
  return request.get("/student/question/mineCourseSelected", data);
}

// 获取问题列表
export async function getQuestionList(data) {
  return request.post("/student/question/mine", data);
}

// 获取学生未读消息
export async function getStudentNotification(data) {
  return request.get("/studentNotification", data);
}

// 设置消息为已读
export async function setStudentNotificationRead(data) {
  return request.patch("/studentNotification/read", data);
}

// 注册 
export async function userStudentRegister(data) {
  return request.post("/openApi/studentAccount/studentRegister", data);
}